'use client';

import { useRef } from 'react';
import { useHtmlHeadState } from '@/components/HtmlHead/HtmlHeadProvider';
import { useOnPageBlur } from '@/components/HtmlHead/hooks/useOnPageBlur';
import { setTitle } from '@/components/HtmlHead/utils';

export interface AnimatedTitleProps {
    delay: number;
    title?: string;
}

export function AnimatedTitle({ delay, title }: AnimatedTitleProps) {
    const { getOriginalTitle } = useHtmlHeadState();
    const position = useRef(0);
    const animatedTitle = useRef<string | undefined>(undefined);

    const blurCallback = () => {
        position.current = 0;
        if (animatedTitle.current === undefined) {
            animatedTitle.current = ` ${(title || getOriginalTitle()).trim()}`;
        }
    };
    const timeoutCallback = () => {
        if (animatedTitle.current === undefined) {
            return;
        }

        setTitle(animatedTitle.current.substring(position.current, animatedTitle.current.length) + animatedTitle.current.substring(0, position.current));
        position.current += 1;
        if (position.current > animatedTitle.current.length) {
            position.current = 0;
        }
    };
    useOnPageBlur({
        blurCallback,
        delay,
        timeoutCallback,
    });

    return null;
}
